import React, { useState } from 'react';
import MainModal from 'components/ModalMain';
import Button from 'components/Button';
import Dropdown from 'components/Dropdown';
import ModalResetPasswordSent from 'screens/ModalResetPasswordSent';
import { Container, Footer, Head } from './styles';
import { useMutation } from '@apollo/client';
import { FORGOT_PASSWORD } from 'graphql/service';
import { debouncedErrorMessage } from 'utils/messageUtil';

const ModalResetPassword  = ({
  hidden,
  disabled,
  buttonLabel,
  buttonStyle,
  email,
  phoneNumber,
  userType
}) => {

  const [isOpen, setIsOpen] = useState(false);
  const [sentIsOpen, setSentIsOpen] = useState(false)
  const [dropdownError, setDropdownError] = useState(false)
  
  const options =[
    {label: "Email", value: "EMAIL"},
    {label: "Phone", value: "SMS"}
  ]

  const [method, setMethod] = useState("")

  const [forgotPassword, { loading }] = useMutation(
    FORGOT_PASSWORD,
    {
      onCompleted: (data) => {
        if(data.forgotPasswordStaff) {
          setIsOpen(false)
          setSentIsOpen(true)
        } else {
          const content = 'Password reset failed!'
          debouncedErrorMessage(content);
        }
      },
      onError: (error) => {
        if (!error.networkError) {
          let content = error.message
          if(error.message.includes('Validation')) {
              content = JSON.stringify(error.graphQLErrors[0]?.extensions?.exception)
          }
          debouncedErrorMessage(content);
        }
      }
    }
  )
    
  const handleReset = () => {
    if(loading) return
    if(method === "") {
      setDropdownError(true)
    } else {
      forgotPassword({
        variables: {
          input: {
            login: method === "EMAIL" ? email : phoneNumber,
            channel: method
          }
        }
      })
    }
  }

  return (
    <>
      <MainModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        className="modal-success"
        buttonLabel={buttonLabel}
        buttonStyle={buttonStyle}
        hidden={hidden}
        disabled={disabled}
        additionalstyle={`
          max-width: 500px;
          .modal-content{
            .close {
              z-index: 200;
            }
            .modal-body {
              height: 100%;
              padding: 24px;
            }
          }
          top: 179px;
        `}
      >
        <Container>
          <Head>Reset Password</Head>
          <div className='text'>
            <div>{`How would you like to send this ${userType==='staff'? 'staff':'customer'} a password reset link, by phone or email?`}</div>
          </div>
          <Dropdown
            options={options}
            error={dropdownError}
            value={options.find(option => option.value === method)?.label || "- Select -"}
            title="PREFERRED METHOD"
            onChange={(e) => {
              setMethod(e)
              setDropdownError(false)
            }}
          />
        </Container>
        <Footer>
          <div className='buttonContainer'>
            <Button
              success
              onClick={handleReset}
              data-loading={loading}
              additionalstyle={`
                width: 148px;
              `}
            >
              {loading? null: 'Reset Password'}
            </Button>
          </div>
        </Footer>
      </MainModal>
      <ModalResetPasswordSent
        isOpen={sentIsOpen}
        setIsOpen={setSentIsOpen}
        type={method}
      />
    </>
  );
}

export default ModalResetPassword;
